import React, { forwardRef, useCallback, useState } from 'react';
import { Input, InputProps, InputRef } from 'antd';

export type MaskInputProps = Omit<InputProps, 'onChange'> & {
  onChange?: (value: string) => void;
};

const CpfCnpjInput = forwardRef<InputRef, MaskInputProps>(
  ({ onChange, ...others }, ref) => {
    const [value, setValue] = useState('');

    const unmaskValue = (val: string) => val.replace(/\D/g, '');

    const formatCpf = (val: string) => {
      return val
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    };

    const formatCnpj = (val: string) => {
      return val
        .replace(/(\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,4})/, '$1/$2')
        .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
    };

    const formatValue = (val: string) => {
      const numericValue = unmaskValue(val);
      if (numericValue.length <= 11) {
        return formatCpf(numericValue);
      } else {
        return formatCnpj(numericValue);
      }
    };

    const handleChange = useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        const rawValue = event.target.value;
        const formattedValue = formatValue(rawValue);
        setValue(formattedValue);

        if (onChange) {
          onChange(formattedValue);
        }
      },
      [onChange],
    );

    return (
      <Input
        ref={ref}
        {...others}
        value={value}
        onChange={handleChange}
        maxLength={18}
      />
    );
  },
);

export default CpfCnpjInput;
